import React, { useState } from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';
import Button from './Button';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'Ερώτηση για πωλήσεις',
    message: ''
  });

  // Νέα states για τη διαχείριση της φόρμας
  const [status, setStatus] = useState({
    submitting: false,
    success: false,
    error: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, success: false, error: false });

    try {
      const response = await fetch('https://formspree.io/f/mgolbloj', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus({ submitting: false, success: true, error: false });
        // Καθαρισμός φόρμας
        setFormData({
          name: '',
          email: '',
          subject: 'Ερώτηση για πωλήσεις',
          message: ''
        });
        
        // Κρύβουμε το μήνυμα επιτυχίας μετά από 5 δευτερόλεπτα
        setTimeout(() => {
          setStatus(prev => ({ ...prev, success: false }));
        }, 5000);
      } else {
        setStatus({ submitting: false, success: false, error: true });
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus({ submitting: false, success: false, error: true });
    }
  };

  useSEO({
    title: 'Επικοινωνία - TailClinic',
    description: 'Επικοινωνήστε με την ομάδα του TailClinic. Είμαστε εδώ να απαντήσουμε σε κάθε ερώτησή σας για το λογισμικό διαχείρισης κτηνιατρείου.',
    canonical: 'https://www.tailclinic.gr/contact',
  });

  return (
    <div style={{ backgroundColor: '#1A202C', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      
      <main style={{ padding: '6rem 0', position: 'relative', overflow: 'hidden', flex: 1, display: 'flex', alignItems: 'center' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.12), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.06), transparent)' }} />
        
        <Container>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '4rem',
            alignItems: 'center',
            position: 'relative'
          }}>
            
            {/* Left Column: Info */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              <div>
                <div style={{
                  display: 'inline-block',
                  padding: '0.35rem 1rem',
                  borderRadius: '9999px',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  color: '#10B981',
                  backgroundColor: 'rgba(16,185,129,0.1)',
                  border: '1px solid rgba(16,185,129,0.2)',
                  marginBottom: '1.5rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  ΕΠΙΚΟΙΝΩΝΙΑ
                </div>
                <h1 style={{
                  fontSize: '3rem',
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '1.25rem',
                  lineHeight: '1.2',
                  letterSpacing: '-0.02em'
                }}>
                  Πώς μπορούμε να σας <span style={{ color: '#10B981' }}>βοηθήσουμε;</span>
                </h1>
                <p style={{
                  fontSize: '1.15rem',
                  color: '#9CA3AF',
                  lineHeight: '1.7',
                  maxWidth: '90%'
                }}>
                  Είτε έχετε απορίες για το λογισμικό, είτε χρειάζεστε τεχνική υποστήριξη, η ομάδα του TailClinic είναι εδώ για εσάς. Συμπληρώστε τη φόρμα και θα σας απαντήσουμε το συντομότερο.
                </p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginTop: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ backgroundColor: '#1F2937', padding: '1rem', borderRadius: '0.75rem', color: '#10B981' }}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                  </div>
                  <div>
                    <div style={{ color: '#E5E7EB', fontWeight: '600', fontSize: '1.05rem' }}>Email Υποστήριξης</div>
                    <a href="mailto:support@tailclinic.gr" style={{ color: '#9CA3AF', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = '#10B981'} onMouseLeave={(e) => e.target.style.color = '#9CA3AF'}>
                      support@tailclinic.gr
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ backgroundColor: '#1F2937', padding: '1rem', borderRadius: '0.75rem', color: '#10B981' }}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                  </div>
                  <div>
                    <div style={{ color: '#E5E7EB', fontWeight: '600', fontSize: '1.05rem' }}>Ώρες Λειτουργίας</div>
                    <div style={{ color: '#9CA3AF' }}>Δευ - Παρ: 09:00 - 17:00</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: The Form */}
            <div style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.35), rgba(59,130,246,0.25))', borderRadius: '1.5rem', padding: '1px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
              <div style={{ backgroundColor: '#1F2937', borderRadius: '1.5rem', padding: '2.5rem' }}>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                  
                  <div>
                    <label style={{ display: 'block', color: '#D1D5DB', fontSize: '0.9rem', fontWeight: '600', marginBottom: '0.5rem' }}>Ονοματεπώνυμο</label>
                    <input
                      type="text" name="name" value={formData.name} onChange={handleChange} required
                      placeholder="π.χ. Γιάννης Παπαδόπουλος"
                      style={{ width: '100%', padding: '0.85rem 1rem', backgroundColor: '#111827', border: '1px solid #374151', borderRadius: '0.5rem', color: 'white', fontSize: '1rem', transition: 'all 0.2s' }}
                      onFocus={(e) => { e.target.style.borderColor = '#10B981'; e.target.style.outline = 'none'; }}
                      onBlur={(e) => e.target.style.borderColor = '#374151'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#D1D5DB', fontSize: '0.9rem', fontWeight: '600', marginBottom: '0.5rem' }}>Email</label>
                    <input
                      type="email" name="email" value={formData.email} onChange={handleChange} required
                      placeholder="ιατρείο@email.com"
                      style={{ width: '100%', padding: '0.85rem 1rem', backgroundColor: '#111827', border: '1px solid #374151', borderRadius: '0.5rem', color: 'white', fontSize: '1rem', transition: 'all 0.2s' }}
                      onFocus={(e) => { e.target.style.borderColor = '#10B981'; e.target.style.outline = 'none'; }}
                      onBlur={(e) => e.target.style.borderColor = '#374151'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#D1D5DB', fontSize: '0.9rem', fontWeight: '600', marginBottom: '0.5rem' }}>Λόγος Επικοινωνίας</label>
                    <select
                      name="subject" value={formData.subject} onChange={handleChange} required
                      style={{ width: '100%', padding: '0.85rem 1rem', backgroundColor: '#111827', border: '1px solid #374151', borderRadius: '0.5rem', color: 'white', fontSize: '1rem', transition: 'all 0.2s', appearance: 'none', cursor: 'pointer' }}
                      onFocus={(e) => { e.target.style.borderColor = '#10B981'; e.target.style.outline = 'none'; }}
                      onBlur={(e) => e.target.style.borderColor = '#374151'}
                    >
                      <option value="Ερώτηση για πωλήσεις">Ερώτηση για πωλήσεις / Τιμές</option>
                      <option value="Τεχνική υποστήριξη">Τεχνική Υποστήριξη</option>
                      <option value="Πρόταση βελτίωσης">Πρόταση λειτουργίας / Feedback</option>
                      <option value="Άλλο">Άλλο</option>
                    </select>
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#D1D5DB', fontSize: '0.9rem', fontWeight: '600', marginBottom: '0.5rem' }}>Μήνυμα</label>
                    <textarea
                      name="message" value={formData.message} onChange={handleChange} required
                      placeholder="Πώς μπορούμε να σας εξυπηρετήσουμε;" rows="5"
                      style={{ width: '100%', padding: '0.85rem 1rem', backgroundColor: '#111827', border: '1px solid #374151', borderRadius: '0.5rem', color: 'white', fontSize: '1rem', resize: 'vertical', minHeight: '120px', fontFamily: 'inherit', transition: 'all 0.2s' }}
                      onFocus={(e) => { e.target.style.borderColor = '#10B981'; e.target.style.outline = 'none'; }}
                      onBlur={(e) => e.target.style.borderColor = '#374151'}
                    />
                  </div>

                  {/* Μηνύματα Επιτυχίας / Σφάλματος (αντί για alert) */}
                  {status.success && (
                    <div style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)', color: '#10B981', padding: '1rem', borderRadius: '0.5rem', fontSize: '0.95rem', border: '1px solid rgba(16, 185, 129, 0.2)', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
                      Το μήνυμά σας στάλθηκε! Θα επικοινωνήσουμε μαζί σας σύντομα.
                    </div>
                  )}

                  {status.error && (
                    <div style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#EF4444', padding: '1rem', borderRadius: '0.5rem', fontSize: '0.95rem', border: '1px solid rgba(239, 68, 68, 0.2)', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                      Υπήρξε ένα πρόβλημα κατά την αποστολή. Παρακαλώ δοκιμάστε ξανά.
                    </div>
                  )}

                  <div style={{ marginTop: '0.5rem' }}>
                    <button 
                      type="submit" 
                      disabled={status.submitting}
                      style={{ 
                        width: '100%', 
                        padding: '1rem', 
                        fontWeight: '800',
                        backgroundColor: status.submitting ? '#374151' : '#10B981',
                        color: status.submitting ? '#9CA3AF' : 'white',
                        border: 'none',
                        borderRadius: '0.5rem',
                        fontSize: '1rem',
                        cursor: status.submitting ? 'not-allowed' : 'pointer',
                        transition: 'all 0.2s'
                      }}
                    >
                      {status.submitting ? 'Αποστολή...' : 'Αποστολή Μηνύματος'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactPage;